import IJsonResponse from "@/utils/types/IJsonResponse";
import { EServices } from "@/types";
import { inject, injectable } from "tsyringe";
import StoreService from "@/store";
import HttpClient from "@/services/HttpClient";
import { IRate } from "../types";

@injectable()
export default class RatesClient {
  constructor(
    @inject(EServices.http) private http: HttpClient,
    @inject(EServices.store) private store: StoreService
  ) {}

  async getRates(): Promise<IJsonResponse> {
    const response = await this.http.get("/v1/app/rates/all");
    this.store.commit("SellModule/setRates", response.data);
    return response;
  }

  async getRate(id: number): Promise<IRate> {
    const response = await this.http.get(`/v1/app/rates/${id}`);
    return response.data;
  }
}
